module.exports = __webpack_public_path__ + "static/media/3DPPA4.b1210af4.jpg";